/* eslint-disable react/destructuring-assignment */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Input, Button } from '../../components';
import { insereDados, clear6to8 } from '../../store/actions/questionario-actions';

function Main(props) {
  const onChange = (event) => {
    const { name, value } = event.target;
    props.insereDados(name, value);
  };
  const [valid, setValid] = useState({});
  const schema = Yup.object().shape({
    atodecorrupcao: Yup.string()
      .min(2, 'Esse campo é obrigatório.')
      .required('Esse campo é obrigatório.'),
  });
  const goProximaQuestao = (e) => {
    e.preventDefault();
    const dados = {
      atodecorrupcao: props.dados.atodecorrupcao,
    };
    schema.validate(dados).then(
      () => {
        props.history.push(props.dados.atodecorrupcao === 'licitações ou contratos' ? '/questao81' : '/questao71');
      },
    ).catch((err) => {
      setValid(err);
    });
  };
  const clear = async () => {
    await props.clear6to8();
  };
  useEffect(() => {
    clear();
    // eslint-disable-next-line
  }, []);
  return (
    <form onSubmit={goProximaQuestao}>
      <h3>6 - O ato de corrupção que você quer relatar está relacionado a:</h3>
      <Input
        type="radio"
        name="atodecorrupcao"
        value="vantagens indevidas"
        checked={props.dados.atodecorrupcao === 'vantagens indevidas'}
        onChange={e => onChange(e)}
      /><span>Vantagens indevidas.</span><br />
      <Input
        type="radio"
        name="atodecorrupcao"
        value="licitações ou contratos"
        checked={props.dados.atodecorrupcao === 'licitações ou contratos'}
        onChange={e => onChange(e)}
      /><span>Licitações ou contratos.</span><br />
      <span className="worning"> {valid.errors && valid.errors[0]}</span><br />
      <Button
        type="button"
        onClick={() => props.history.push(props.dados.tipoato === 'autor' ? '/questao52' : '/questao51')}
      >
        QUESTÃO ANTERIOR
      </Button>
      <Button
        type="submit"
        className="button"
      >PRÓXIMA QUESTÂO
      </Button>
    </form>
  );
}
const mapStateToProps = state => (
  {
    dados: state.QuestionarioReducers,
  }
);
export default connect(mapStateToProps, { insereDados, clear6to8 })(Main);
